<template>
    <modal class="remarkModel" :isShow="isShow || visible">
        <div class="header">{{title || '请输入原因'}}
            <i class="iconfont icon-guanbi" @click="hide()"></i>
        </div>
        <div class="modal-body">
            <div class="input-box">
                <textarea v-model="remarkText" :placeholder="placeholder" maxlength="50"></textarea>
                <div class="word-count">{{remarkText.length}}/50</div>
            </div>
        </div>
        <div class="footer-box">
            <button class="btn" @click="hide()">取消</button>
            <button class="btn btn-confirm" @click="confirm()">确认</button>
        </div>
    </modal>
</template>

<script>
// 备注输入弹层（锁台原因/退订原因）
export default {
    name: 'remarkModel',
    emits:["close","confirm"],
    props: {
        isShow: Boolean,
        title: {
            type: String,
            default: '请输入原因'
        }
    },
    data() {
        return {
            visible: false,
            placeholder: '请输入原因',
            //原因id
            tempID:"",
            //原因
            remarkText: '',
            callback: null,
        }
    },
    mounted() {
        this.$nextTick(() => {
            this.init();
        });
    },
    watch: {
        isShow(newValue) {
            if (newValue) {
                this.init();
            }
        }
    },
    methods: {
        /**初始化数据 */
        init() {
            this.remarkText = '';
        },
        /**打开弹层，外部调用 */
        open() {
            this.visible = true;
            this.init();
        },
        /**设置回调，外部调用 */
        cllBack(callback) {
            this.callback = callback;
        },
        hide() {
            this.visible = false;
            this.$emit("close");
        },
        confirm() {
            if (this.callback) {
                const result = this.callback(this.remarkText);
                if (result !== false) {
                    this.hide();
                }
            } else {
                this.$emit("confirm", this.remarkText);
                this.hide();
            }
        }
    }
}
</script>
<style lang="scss">
@import './remarkModel.scss'
</style>
